<template>
    <my-form
    class="form-page"
    v-model="form"
    table
    label-width="180px"
    @cancle="cancleHandler"
    :submit-url="`${getGetters('bidUrl')}/newpingbiao/pbwyh/cyadd.json`">

        <el-form-item
        label="专家姓名"
        prop="zjname"
        :rules="newRule('专家姓名', 'required')">
            <el-input
                v-model="form.zjname">
            </el-input>
        </el-form-item>
        <el-form-item
        label="身份证号/专家证书编号"
        prop="e_zjsfzh"
        :rules="[...newRule('身份证号/专家证书编号', 'required'), {validator:validateSfzh, trigger:'blur'}]">
            <el-input
                v-model="form.e_zjsfzh">
            </el-input>
        </el-form-item>

        <el-form-item
        label="专家身份"
        prop="zjsf"
        :rules="newRule('专家身份', 'required')">
            <my-radio
                :data="[{key:'0', value:'评标专家'},{key:'1', value:'业主代表'}]"
                v-model="form.zjsf"
            >
            </my-radio>
        </el-form-item>
     
        <el-form-item
        class="table-full-row"
        label="专家手机"
        prop="e_zjsj"
        :rules="newRule('专家手机', 'required', 'mobile')">
            <el-input
                v-model="form.e_zjsj">
            </el-input>
        </el-form-item>

        <el-form-item
        label="工作单位"
        prop="e_gzdw"
        :rules="newRule('工作单位', 'required')">
            <el-input
                v-model="form.e_gzdw">
            </el-input>
        </el-form-item>
        <el-form-item
        label="专家职称"
        prop="e_zjzc"
        :rules="newRule('专家职称', 'required')">
            <el-input
                v-model="form.e_zjzc">
            </el-input>
        </el-form-item>

        <el-form-item
        label="专家登录密码"
        prop="e_pwd"
        :rules="newRule('专家登录密码', 'required')">
            <el-input
                type="password"
                v-model="form.e_pwd">
            </el-input>
        </el-form-item>
        <el-form-item
        label="确认密码"
        prop="e_pwdqr"
        :rules="[...newRule('确认密码', 'required'), {validator:validatePass, trigger:'blur'}]">
            <el-input
                type="password"
                v-model="form.e_pwdqr">
            </el-input>
        </el-form-item>

        <template slot="btn" slot-scope="scope">
            <el-button
            @click="saveHandler(0, scope.submitHandler)"
            type="primary"
            icon="el-icon-circle-check">
                保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { },
    props: {
        query: {
            type: Object,
            default: () => ({})
        },
        data:{
            type: Object,
            default: () => ({})
        },
        
    },
    data() {
       
        return {
            form: {},
            isnzk:''
        }
    },
  
    computed: {

    },
    methods: {
        saveHandler(type, cb) {
            this.form.shbj = type;
            cb && cb();
        },
        submitHandler:function(){
            var that=this
            that.$post(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/cyadd.json`,this.form, (data, res) => {
                if (res.result) {
                    ShowMsg(res.msg,'success')
                } else {
                    ShowMsg(res.msg)
                }
            }); 
        },
        validatePass(rule, value, callback) {
            if(value !== this.form.e_pwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        },
        validateSfzh(rule, value, callback) {
            if(value && (value.length < 10 || value.length > 20)) {
                callback(new Error('专家身份证号/专家证书编号 格式错误'));
            } else {
                callback();
            }                                                  
        },
    },                                                       
    created() {
          
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/cygl.json`, 
        {  
            id:this.data.id,
           procode:this.getQuery('procode'),
           zjsqcode:this.getQuery('zjsqcode'),
           zgys:this.getQuery('zgys'),             
        }                           
        , data => {
          
            this.form = data.cymodel;
            this.isnzk=data.isnzk
        });
    },
    mounted() {
       
      
    }
}
</script>

<style scoped lang="scss">

</style>
       